export var stylesPdfData = {
    page: {
        fontFamily: "THSarabun",
        fontSize: 16,
        padding: 20,
        lineHeight: 1
    },
    section: {
        marginBottom: 12
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start"
    },
    logo: {
        width: 100,
        height: 61
    },
    textHeaderCompany: {
        fontSize: 18,
        fontFamily: "THSarabun",
        fontWeight: "bold",
        marginBottom: 1
    },
    textDetailCompany: {
        fontSize: 16,
        fontFamily: "THSarabun"
    },
    centerHeaderText: {
        textAlign: "center",
        marginVertical: 12,
        fontSize: 18,
        fontFamily: "THSarabun",
        fontWeight: "bold"
    },
    rightDetailText: {
        fontFamily: "THSarabun",
        fontSize: 16,
        textAlign: "right"
    },
    paragraph: {
        fontSize: 16,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: "THSarabun",
        marginVertical: 15
    },
    bold: {
        fontFamily: "THSarabun",
        fontSize: 16,
        fontWeight: "bold"
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 20,
        right: 20,
        textAlign: "right",
        fontFamily: "THSarabun",
        fontSize: 16,
        fontWeight: "bold"
    },
    sectionHeader: {
        fontFamily: "THSarabun",
        fontSize: 16,
        fontWeight: "bold"
    },
    paragraphSignature: {
        fontSize: 16,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: "THSarabun",
        marginVertical: 40
    },
    paragraphTextC: {
        fontSize: 16,
        lineHeight: 1.2,
        fontFamily: "THSarabun",
        marginBottom: 1
    },
    paddingLeftTextS1: {
        paddingLeft: 40
    },
    paddingLeftTextS2: {
        paddingLeft: 60
    },
    signatureRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20,
        marginVertical: 40
    },
    signatureRow2: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20
    },
    signatureRow3: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginVertical: 10
    },
    signatureBox: {
        minWidth: "45%",
        alignItems: "center"
    },
    signatureLine: {
        fontSize: 16,
        fontFamily: "THSarabun",
        marginBottom: 4,
        textAlign: "center",
        fontWeight: "bold"
    },
    signatureName: {
        fontSize: 16,
        fontFamily: "THSarabun",
        textAlign: "center",
        fontWeight: "bold"
    },
    paragraphPadding_40: {
        fontSize: 16,
        fontFamily: "THSarabun",
        marginVertical: 5,
        paddingLeft: 40
    },
    channelRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingLeft: 100,
        marginVertical: 10
    },
    channelBox: {
        minWidth: "45%",
        alignItems: "start"
    },
    channelLine: {
        fontSize: 16,
        fontFamily: "THSarabun",
        marginBottom: 4,
        textAlign: "left"
    },
    channelName: {
        fontSize: 16,
        fontFamily: "THSarabun",
        textAlign: "left"
    },
    table: {
        display: "flex",
        width: "auto",
        //borderStyle: 'solid',
        //borderWidth: 1,
        //borderColor: '#000',
        borderBottomWidth: 0
    },
    tableRow: {
        flexDirection: "row"
    },
    tableColHeader: {
        //width: '25%',
        borderStyle: "solid",
        borderWidth: 1,
        justifyContent: "center",
        borderColor: "#F6E1E3",
        backgroundColor: "#F6E1E3",
        // borderLeftWidth: 0,
        // borderTopWidth: 0,
        padding: 5
    },
    tableCol: {
        //width: '25%',
        justifyContent: "center",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#909090",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth: 0,
        padding: 5
    },
    tableCellHeader: {
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "THSarabun"
    },
    tableCell: {
        fontSize: 12,
        fontFamily: "THSarabun",
        justifyContent: "center"
    },
    tableCol5P: {
        width: "5%"
    },
    tableCol10P: {
        width: "10%"
    },
    tableCol15P: {
        width: "15%"
    },
    tableCol20P: {
        width: "20%"
    },
    tableCol25P: {
        width: "25%"
    },
    tableCol30P: {
        width: "30%"
    },
    tableCol35P: {
        width: "35%"
    },
    tableCol40P: {
        width: "40%"
    },
    tableCol45P: {
        width: "45%"
    },
    tableCol50P: {
        width: "50%"
    },
    boxInfoPartner: {
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: 60
    },
    boxInfoDocument: {
        fontSize: 18,
        fontFamily: "THSarabun",
        fontWeight: "bold",
        color: "rgba(220,53,69,1)"
    },
    textDetail14P: {
        fontSize: 14,
        fontFamily: "THSarabun",
        justifyContent: "center"
    },
    textDetail14B: {
        fontSize: 14,
        fontFamily: "THSarabun",
        fontWeight: "bold",
        justifyContent: "center"
    },
    textDetail16P: {
        fontSize: 16,
        fontFamily: "THSarabun",
        justifyContent: "center"
    },
    textDetail16B: {
        fontSize: 16,
        fontFamily: "THSarabun",
        fontWeight: "bold",
        justifyContent: "center"
    },
    imageDetailIcon: {
        width: 12,
        height: 12,
        marginTop: 2,
        justifyContent: "center"
    },
    signatureBorder: {
        fontSize: 14,
        fontFamily: "THSarabun",
        justifyContent: "center",
        textAlign: "center",
        borderTop: "1px solid #d8d8d8",
        width: "80%",
        paddingTop: 3,
        marginHorizontal: "auto"
    }
};
